import React from "react";
import "./PremiumLoader.css";

export default function PremiumLoader({
  text = "Loading data...",
  subText = "Please wait a moment",
  height = "260px",
}) {
  return (
    <div className="premium-loader-wrap" style={{ minHeight: height }}>
      <div className="premium-loader-card">
        <div className="premium-loader-ring">
          <div className="premium-loader-dot"></div>
        </div>

        <div className="premium-loader-text">{text}</div>
        <div className="premium-loader-subtext">{subText}</div>

        <div className="premium-loader-lines">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}
